<script>
  import { _ } from "svelte-i18n";
  import { Route, router, meta } from "tinro";
  import { BASE_URL } from "../utilities/config.js";
  import { createEventDispatcher, onMount } from "svelte";
  import { postJsonFile } from "../utilities/Utils.svelte";
  import RangeSlider from "svelte-range-slider-pips";
  import { postJsonFileNoResponse } from "../utilities/Utils.svelte";
  import {
    currentPage,
    skillId,
    cid,
    userId,
    userName,
    assessmentType,
    assessmentId,
    instanceId,
    assessmentState,
    assessmentDefinitionId,
    activationCode,
    invitationNumber,
    readinessCheckCompleted,
    showCompletedSelection,
  } from "../utilities/DataStore";
  import { api } from "../utilities/Utils.svelte";
  import { sanitizeAssessmentHtml } from "../utilities/TextSanitizer.js";
    import ReportIssueModal from "./components/ReportIssueModal.svelte";
  import { isIeltsInvitation } from "./ieltsOverall.mjs";

  let errorMsg = undefined;
  let loadingState = "NEW";
  let certificationScore = undefined;
  let certificationType = undefined;

  let invitationDetail = undefined;
  let invitationDetailStatus = "NEW";

  $: ieltsInvitation = isIeltsInvitation(invitationDetail);

  let exerciseId = null;

  onMount(async () => {
    if ($invitationNumber) {
      Promise.allSettled([
        getAssessmentInvitationDetail(),
        loadDataFromInvitation(),
      ])
        .then((results) => {
          loadingState = "OK";
        })
        .catch((error) => {
          console.error("loadData error", error);
          errorMsg = "ERROR_LOADING_ASSESSMENT";
          assessmentList = [];
          loadingState = "ERROR";
        });
    } else {
      loadData();
    }
  });

  let assessmentList = [];

  let allFinished = false;

  function isWritingPreviewCard(section) {
    const marker = `${section?.name || ""} ${section?.code || ""} ${section?.description || ""}`.toLowerCase();
    return marker.includes("writ") || marker.includes("test");
  }

  function loadData() {
    loadingState = "LOADING";

    return api
      .get(`public/assessment/definition`)
      .json()
      .then((data) => {
        assessmentList = data
          .filter((a) => a.activationCode === $activationCode)
          .filter((a) => a.status === "ACTIVE" || a.status === "DRAFT");
        console.log("exerciseListData", assessmentList);
        loadingState = "OK";
      })
      .catch((error) => {
        console.log("catch error", error);
        errorMsg = "ERROR_LOADING_ASSESSMENT";
        assessmentList = [];
        loadingState = "ERROR";
      });
  }

  async function getAssessmentInvitationDetail() {
    return api
      .get(`public/assessment/invitation/${$invitationNumber}`)
      .json()
      .then((data) => {
        console.log("invitation successful", data);
        invitationDetail = data;
        invitationDetailStatus = "OK";
        $userId = data.clientId;
        $userName = data.clientName;
      })
      .catch((error) => {
        invitationDetailStatus = "ERROR";
        console.log("error Definition", error);
      });
  }

  // A cancelled part, or one closed when a GJun attempt passed its deadline.
  function isClosed(part) {
    return part?.invDefStatus === "CANCEL" || part?.invDefStatus === "EXPIRED";
  }

  async function loadDataFromInvitation() {
    loadingState = "LOADING";
    return api
      .get(
        `public/assessment/invitation/${$invitationNumber}/definitions-detail`,
      )
      .json()
      .then((data) => {
        assessmentList = data.map((e) => {
          let isResumeAllowed =
            (!e?.idInstance ||
            (e?.invDefStatus === "IN_PROGRESS" &&
              e?.deadlineAt &&
              new Date(e.deadlineAt+"Z")) > new Date())
              ? true
              : false;

          return {
            id: e.idDefinition,
            code: e.code,
            name: e.name,
            description: e.description,
            idInstance: e.idInstance,
            totalDurationLimit: e.totalDurationLimit,
            targetDurationLimit: e.expectedDuration || e.targetDurationLimit,
            status: e.status,
            invDefStatus: e.invDefStatus,
            isResumeAllowed: isResumeAllowed,
          };
        });

        const DONE_STATUSES = ["SCORED", "DONE", "SUBMITTED", "ENDED"];
        let count = 0;
        let countDone = 0;
        assessmentList.forEach((e) => {
          count++;
          if (DONE_STATUSES.includes(e.invDefStatus) || DONE_STATUSES.includes(e.status) || isClosed(e)) {
            countDone++;
          }
        });
        allFinished = count > 0 && count === countDone;

        // Keep users on selection even when all parts are complete, so they
        // can see all three completed sections.
        if ($showCompletedSelection) {
          // Consume one-time override after returning from thank-you page.
          $showCompletedSelection = false;
        }

        console.log("exerciseListData", assessmentList);
        loadingState = "OK";
      })
      .catch((error) => {
        console.log("catch error", error);
        errorMsg = "ERROR_LOADING_ASSESSMENT";
        assessmentList = [];
        loadingState = "ERROR";
      });
  }

  async function startAssessment(assessmentTypeValue, assessmentDefinitionIdValue) {
    console.log(555);

    $assessmentType = assessmentTypeValue;
    $assessmentDefinitionId = assessmentDefinitionIdValue;

    if (assessmentTypeValue === "TOEIC_DEMO") {
      $currentPage = "PreviousExam";
      return;
    }

    try {
      await startAssessmentInstance(
        $userId,
        $userName,
        $assessmentId,
        $assessmentType,
        $skillId,
        $cid,
      );
      $currentPage = "AssessmentOverview";
    } catch (error) {
      errorMsg = "Error" + error;
      loadingState = "ERROR";
    }
  }

  async function startAssessmentInstance(
    clientId,
    clientName,
    assessmentId,
    assessmentDefinitionCode,
    skillId,
    cid,
  ) {
    const assessmentInstance = {
      clientId: clientId,
      clientName: clientName,
      assessmentId: assessmentId,
      status: "NEW",
      assessmentDefinitionCode: assessmentDefinitionCode,
      assessmentDefinitionId: $assessmentDefinitionId,
      skillId: skillId,
      cid: cid,
      invitationNumber: $invitationNumber,
    };

    await postJsonFile(
      BASE_URL + "/public/assessment/instance",
      { "Content-Type": "application/json" },
      {},
      assessmentInstance,
    )
      .then((data) => {
        console.log("send data to sensay", data);
        $assessmentDefinitionId = data.assessmentDefinitionId;
        $assessmentState = data.status;
        $instanceId = data.id;
      })
      .catch((error) => {
        errorMsg = error;
        console.error("error sending data to sensay", error);
        throw new Error(error);
      });
  }

  function resumeAssessment(defId, instId) {
    console.log("resumeAssessment");
    $assessmentDefinitionId = defId;
    $instanceId = instId;
    $currentPage = "AssessmentOverview";
  }

  function openInvitationReport() {
    router.goto("/invitation-report/" + $invitationNumber);
    $currentPage = "AssessmentInvitationReport";
  }
</script>

<div class="selection-root">
  <div class="px-4 py-5 my-1 text-center selection-shell">
    <div class="selection-content mx-auto">
      <div class="mb-4">
        <span
          ><img
            style="margin-right: 1em;"
            src="assets/img/logo_horizontal_nobg2.png"
            alt="OksenSay"
          /></span
        >
        {#if $activationCode === "NTNU"}
          <span
            ><a href="https://www.obe.ntnu.edu.tw/index.php/en/rcemi/">
              <img src="assets/img/ntnu_emi_logo.png" alt="NTNU" /></a
            ></span
          >
        {/if}
      </div>

      {#if !allFinished}<h2 class="lead mb-4">Select which section of the assessment you'd like to start with</h2>{/if}

      {#if allFinished === true}<h3 class="mb-2">
          {$_("ALL_PARTS_FINISHED")}
        </h3>
        <p class="text-muted mb-3">
          The final result will be calculated by examiners and the system. Thank you for taking this assessment.
        </p>
        <!-- An IELTS invitation always has an aggregated report to show: it is
             built from the four skill bands the invitation already carries,
             rather than from a certificate the organization has to opt into. -->
        {#if invitationDetail?.reportType === "TOEIC_CERT" || ieltsInvitation}
          <button class="btn btn-primary" on:click={openInvitationReport}
            >{$_("VIEW_REPORT")}</button
          >
        {/if}
      {/if}

      {#if loadingState === "LOADING"}
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3 selection-grid selection-loading-grid">
          {#each [1, 2, 3, 4] as _}
            <div class="col mb-2">
              <div class="card shadow-sm mb-4 h-100 loading-card">
                <div class="card-body text-center d-flex flex-column">
                  <div class="loading-shimmer loading-icon"></div>
                  <div class="loading-shimmer loading-label"></div>
                  <div class="loading-shimmer loading-text"></div>
                  <div class="loading-shimmer loading-text"></div>
                  <div class="loading-shimmer loading-duration mt-auto"></div>
                </div>
                <div class="card-footer">
                  <div class="loading-shimmer loading-button"></div>
                </div>
              </div>
            </div>
          {/each}
        </div>
{:else if loadingState === "ERROR" || (loadingState === "OK" && assessmentList.length === 0)}
        <div class="alert alert-danger mt-4" role="alert">
          <h4 class="alert-heading">{$_("ERROR_LOADING_ASSESSMENT") || "Error Loading Assessment"}</h4>
          <p>There was a problem loading your assessment data. This may be due to a network error, an invalid invitation, or your session may have expired.</p>
          <hr>
          <p class="mb-0">Please try to login again. If the problem persists, try to report the issue.</p>
          <button class="btn btn-outline-danger mt-3" on:click={() => { $invitationNumber = undefined; $activationCode=undefined; $currentPage = "Landing"; }}>Back to Login</button>
        </div>
      {:else}
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3 selection-grid">
          {#each assessmentList as a}
          <div class="col mb-2">
            <div class="card shadow-sm mb-4 h-100 {["SCORED","DONE","SUBMITTED","ENDED"].includes(a.status) || ["SCORED","DONE","SUBMITTED","ENDED"].includes(a.invDefStatus) || isClosed(a) ? 'completed' : ''}">
              <div class="card-header">{a.name}</div>
              <div class="card-body text-center d-flex flex-column">
                <div class="section-icon">
                  {#if a.name?.toLowerCase().includes("listen")}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-headphones w-10 h-10" aria-hidden="true"><path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path></svg>
                  {:else if a.name?.toLowerCase().includes("read")}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open w-10 h-10" aria-hidden="true"><path d="M12 7v14"></path><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path></svg>
                  {:else if a.name?.toLowerCase().includes("speak")}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mic w-10 h-10" aria-hidden="true"><path d="M12 19v3"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><rect x="9" y="2" width="6" height="13" rx="3"></rect></svg>
                  {:else if isWritingPreviewCard(a)}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-pen-line w-10 h-10" aria-hidden="true"><path d="M12 20h9"></path><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path><path d="M15 5l3 3"></path></svg>
                  {:else}
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                    </svg>
                  {/if}
                </div>
                {#if a.name?.toLowerCase().includes("listen")}
                  <h4 class="section-label">Listening</h4>
                {:else if a.name?.toLowerCase().includes("read")}
                  <h4 class="section-label">Reading</h4>
                {:else if a.name?.toLowerCase().includes("speak")}
                  <h4 class="section-label">Speaking</h4>
                {:else if isWritingPreviewCard(a)}
                  <h4 class="section-label">Writing</h4>
                {/if}
                <p class="card-text text-left">{@html sanitizeAssessmentHtml(a.description) || ""}</p>
                <!-- <p class="card-text">{$_("SCORE_NOT_REPRESENTATIVE")}</p> -->

                <p class="text-muted mt-auto">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M12.49 2C6.97 2 2.5 6.48 2.5 12C2.5 17.52 6.97 22 12.49 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.49 2ZM12.5 20C8.08 20 4.5 16.42 4.5 12C4.5 7.58 8.08 4 12.5 4C16.92 4 20.5 7.58 20.5 12C20.5 16.42 16.92 20 12.5 20ZM12.28 7H12.22C11.82 7 11.5 7.32 11.5 7.72V12.44C11.5 12.79 11.68 13.12 11.99 13.3L16.14 15.79C16.48 15.99 16.92 15.89 17.12 15.55C17.33 15.21 17.22 14.76 16.87 14.56L13 12.26V7.72C13 7.32 12.68 7 12.28 7Z"
                        fill="black"
                        fill-opacity="0.54"
                      />
                    </g>
                  </svg>
                  {a.targetDurationLimit || "20"}
                  {$_("MINS")}
                </p>
              </div>
              <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="btn-group">
                    {#if a?.invDefStatus === "EXPIRED"}
                      <span class="status-pill status-cancelled">{$_("EXPIRED")}</span>
                    {:else if a?.isResumeAllowed && a?.idInstance}
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-start"
                        on:click={() => resumeAssessment(a.id, a.idInstance)}
                      >
                        {$_("RESUME_ASSESSMENT")}
                      </button>
                    {:else if a?.idInstance || a?.invDefStatus === "CANCEL"}
                      <span class="status-pill {a?.invDefStatus === 'CANCEL' ? 'status-cancelled' : 'status-completed'}">
                        {#if a?.invDefStatus === "CANCEL"}
                          {$_("CANCELLED")}
                        {:else}
                          Completed
                        {/if}
                      </span>
                    {:else}
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-start"
                        on:click={() => startAssessment(a.code, a.id)}
                        >{$_("START_ASSESSMENT")}</button>
                    {/if}
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/each}
        </div>
      {/if}
    </div>
  </div>


  <!-- Report Issue Button and Modal -->
  <ReportIssueModal instanceId={$instanceId} exerciseId={exerciseId} invitationNumber={$invitationNumber} />
</div>

<style>
  .card {
    min-height: 22em;
    background-color: #ffffff;
    text-align: center;
    border: 1px solid #d9eef2;
    border-radius: 16px;
    box-shadow: 0 10px 24px rgba(0, 91, 111, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .card:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 32px rgba(0, 82, 97, 0.14);
    border-color: #00a094;
  }

  .card.active,
  .card.active:hover {
    border-color: #00a094;
    box-shadow: 0 16px 32px rgba(0, 82, 97, 0.2);
  }

  .card.completed {
    background-color: #f2fbfa;
    border-color: #d7efec;
    color: #4d7f78;
    box-shadow: none;
  }

  .card.completed:hover {
    transform: none;
    box-shadow: none;
    border-color: #d7efec;
  }

  .card.completed .card-body,
  .card.completed .card-footer,
  .card.completed .card-text,
  .card.completed p,
  .card.completed .section-icon {
    opacity: 0.72;
  }

  .card.completed .section-icon {
    background-color: #e6f6f3;
    color: #6f9f98;
    box-shadow: none;
    border-color: #d7efec;
  }

  .card.completed .btn-start,
  .card.completed .btn-outline-primary.btn-start,
  .card.completed button.btn-outline-primary.btn-start:disabled {
    background-color: #e4eceb !important;
    color: #7a8f8a !important;
    border-color: #e4eceb !important;
    box-shadow: none !important;
    cursor: not-allowed;
  }

  .card.completed .btn-start:hover,
  .card.completed .btn-outline-primary.btn-start:hover,
  .card.completed button.btn-outline-primary.btn-start:disabled:hover {
    filter: none !important;
    transform: none !important;
    background-color: #e4eceb !important;
  }

  .status-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 220px;
    min-height: 52px;
    padding: 0.74rem 1.6rem;
    border-radius: 8px;
    font-size: 1.05rem;
    font-weight: 700;
    box-shadow: none;
    cursor: default;
    line-height: 1.2;
  }

  .status-completed {
    background-color: #dff3ef;
    color: #6e8d88;
    border: 1px solid #d4ebe7;
    text-transform: none;
    box-shadow: none;
  }

  .status-cancelled {
    background-color: #fde8e8;
    color: #991b1b;
  }

  .card-header {
    display: none;
  }

  .selection-root {
    width: 100%;
    max-width: 1490px;
    margin-left: auto;
    margin-right: auto;
  }

  .selection-grid {
    justify-content: center;
  }

  /* Add extra spacing only for wrapped rows: +24px after the first row */
  .selection-grid > .col:nth-child(n + 2) {
    margin-top: 24px;
  }

  @media (min-width: 768px) {
    .selection-grid > .col:nth-child(n + 2) {
      margin-top: 0;
    }

    .selection-grid > .col:nth-child(n + 3) {
      margin-top: 24px;
    }
  }

  @media (min-width: 992px) {
    .selection-grid > .col:nth-child(n + 3) {
      margin-top: 0;
    }

    .selection-grid > .col:nth-child(n + 5) {
      margin-top: 24px;
    }
  }

  .selection-content {
    width: 100%;
    max-width: 1490px;
  }

  .card-body {
    font-size: 0.95rem;
    font-weight: 400;
    min-height: 22em;
    padding: 2.2rem 1.4rem;
    text-align: center;
    flex: 1 1 auto;
  }

  .card-footer {
    background-color: transparent;
    border-top: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0.75rem 1.2rem;
    margin-top: auto;
  }

  .card-footer .btn-group {
    width: 100%;
    min-height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.25rem;
  }

  .btn-start {
    background-color: #00a094;
    color: #ffffff;
    border: 0;
    margin: 0;
    padding: 0.74rem 1.6rem;
    font-size: 1.05rem;
    font-weight: 700;
    border-radius: 8px;
    box-shadow: 0 5px 12px rgba(0, 152, 135, 0.32);
    transition: transform 0.2s ease, filter 0.2s ease;
    min-width: 220px;
    min-height: 52px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    white-space: normal;
    text-align: center;
    word-break: normal;
  }

  .btn-start:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  .section-icon {
    width: 90px;
    height: 90px;
    margin: 0 auto 1.2rem;
    border-radius: 50%;
    background-color: #eafdfc;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00a094;
    box-shadow: 0 10px 18px rgba(0, 160, 148, 0.22);
    border: 1px solid #d6f5f1;
  }

  .section-icon svg {
    width: 40px;
    height: 40px;
  }

  .section-label {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0.5rem 0 1rem;
    color: #333;
  }

  .loading-card {
    pointer-events: none;
  }

  .loading-shimmer {
    position: relative;
    overflow: hidden;
    background: #dce3ea;
    border-radius: 10px;
  }

  .loading-shimmer::after {
    content: "";
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.62), transparent);
    animation: selection-loading-shimmer 1.2s infinite;
  }

  .loading-icon {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    margin: 0 auto 1.1rem;
  }

  .loading-label {
    height: 28px;
    width: 54%;
    margin: 0 auto 0.9rem;
  }

  .loading-text {
    height: 14px;
    width: 90%;
    margin: 0 auto 0.55rem;
  }

  .loading-duration {
    height: 22px;
    width: 40%;
    margin: 1rem auto 0;
  }

  .loading-button {
    height: 52px;
    width: 220px;
    max-width: 100%;
    margin: 0 auto;
    border-radius: 8px;
  }

  @keyframes selection-loading-shimmer {
    100% {
      transform: translateX(100%);
    }
  }

  @media (max-width: 1200px) {
    .selection-grid {
      margin-left: -7.5px;
      margin-right: -7.5px;
    }

    .selection-grid > .col {
      padding-left: 7.5px;
      padding-right: 7.5px;
    }

    .card-footer .btn-group > .btn-start {
      flex: 0 0 auto;
      width: auto;
      min-width: 180px;
      max-width: 220px;
      margin-left: auto;
      margin-right: auto;
    }

    .status-pill {
      width: calc(100% - 16px);
      min-width: 0;
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
    }

    .card-footer .btn-group > .btn-start,
    .status-pill {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
  }

  @media (max-width: 767.98px) {
    .selection-root {
      max-width: 100vw;
      padding-left: 0;
      padding-right: 0;
    }

    .selection-shell {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .selection-content {
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
    }

    .selection-grid {
      justify-content: center;
      margin-left: 0;
      margin-right: 0;
    }

    .selection-grid > .col {
      flex: 0 0 90vw !important;
      max-width: 90vw !important;
      display: flex;
      justify-content: center;
      padding-left: 0;
      padding-right: 0;
    }

    .selection-grid > .col > .card {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
